import { type ValidationError } from '@adv-frontend/form-kit';

export const INVALID_PHONE_FORMAT_CODE = 'INVALID_PHONE_FORMAT';

export type InvalidPhoneFormatValidationError = ValidationError<typeof INVALID_PHONE_FORMAT_CODE>;

export const INVALID_PHONE_FORMAT_MESSAGE = 'Неверный формат телефона';
